
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/order-online",
      function () {
        return require("private-next-pages/order-online.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/order-online"])
      });
    }
  